import { useConfig } from 'ha/helpers/config';
import { useFeatureFlags } from 'ha/modules/FeatureFlags';

export function useIdP() {
  const { authEnabled } = useConfig();
  const { enableOAuthTokamak } = useFeatureFlags();

  return {
    isIdPEnabled: authEnabled && enableOAuthTokamak === 'on',
  };
}
